import { Panel, Tab } from "@mcleod/components";
import { AutogenLayoutSettlementPayrollHistoryList } from "./autogen/AutogenLayoutSettlementPayrollHistoryList";

export class SettlementPayrollHistoryList extends AutogenLayoutSettlementPayrollHistoryList {
    override onLoad() {
        this.switchSwitchVoided.allowIndeterminate = true;
        this.switchSwitchVoided.checked = undefined;
        this.switchSwitchProcessed.allowIndeterminate = true;
        this.switchSwitchProcessed.checked = undefined;
    }

    styleTab(tab: Tab) {
        tab.heading.setProps({ color: "subtle.light", fontBold: false, borderWidth: 0 });
        tab.headingLabel.setProps({ color: "McLeodPrimary", fontSize: "xlarge", fontBold: true });
    }

    clearSearchPanel(panel: Panel) {
        this.mainDataSource.searchRow.clear();
        this.textboxPayeeCode.clear();
        this.textboxCheckAmount.clear();
        this.textboxCheckDate.clear();
        this.textboxCheckNumber.clear();
        this.textboxPaymentMethod.clear();
        this.textboxPayeeMethod.clear();
        this.switchSwitchProcessed.checked = undefined;
        this.switchSwitchVoided.checked = undefined;
        this.textboxSource.clear();
        this.textboxFactCompany.clear();

        panel.displayData(this.mainDataSource.searchRow, null, 0);
    }
}